import { environmentHttpClient } from "client/Api/httpClient";
import { NameConflictResolutionKind, UploadResult } from "../common";

export type OpenInWopiModel = {
	wopiUrl: string;
};

export function openInWopiPopup(
	serverId: number,
	fileId: string,
	async?: boolean,
	signal?: AbortSignal
): Promise<OpenInWopiModel> {
	return environmentHttpClient.get<OpenInWopiModel>(
		`Documents/WebDav/${serverId}/OpenInWopiPopup?fileId=${encodeURIComponent(fileId)}`,
		undefined,
		{ signal, async }
	);
}

export type FileUploadModel = {
	file: File;
	fileName: string;
	path: string;
	nameConflictResolution?: NameConflictResolutionKind;
};

export function uploadFile(
	serverId: number,
	folderId: string,
	uploadInfo: FileUploadModel,
	signal?: AbortSignal
): Promise<UploadResult> {
	const {
		file,
		fileName,
		path,
		nameConflictResolution
	} = uploadInfo;

	const formData = new FormData();

	formData.append("file", file);
	formData.append("fileName", fileName);
	formData.append("path", path);

	if (typeof nameConflictResolution === "number") {
		formData.append("nameConflictResolution", nameConflictResolution.toString());
	}

	return environmentHttpClient.postFormData<UploadResult>(
		"Documents/WebDav/" + serverId + "/UploadFile?folderId=" + encodeURIComponent(folderId),
		formData,
		{ signal }
	);
}
